import { FC } from 'react'
import './ProgressBar.scss'

export type ProgressBarProps = {
  current: number
  goal: number
  className?: string
  showLabel?: boolean
}

export const ProgressBar: FC<ProgressBarProps> = ({
  current,
  goal,
  className = '',
  showLabel = false,
}) => {
  const safeGoal = goal > 0 ? goal : 0
  const ratio =
    safeGoal === 0 ? 0 : Math.min(1, Math.max(0, current / safeGoal))
  const percent = Math.round(ratio * 100)

  return (
    <div className={`ProgressBar ${className}`}>
      {showLabel && (
        <div className="ProgressBar__label">
          {current.toLocaleString()} / {goal.toLocaleString()} ({percent}%)
        </div>
      )}
      <div className="ProgressBar__track">
        <div
          className="ProgressBar__fill"
          style={{ width: `${percent}%` }}
          aria-valuenow={percent}
          aria-valuemin={0}
          aria-valuemax={100}
          role="progressbar"
        />
      </div>
    </div>
  )
}
